import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useEffect, useState } from 'react';
import PhoneInput from 'react-phone-input-2';

import { STRINGS } from 'src/commons';
import ImagePicker from 'src/components/imagePicker';

const TrainerForm = ({
  errors,
  handleBlur,
  handleChange,
  handleSubmit,
  setFieldValue,
  isSubmitting,
  touched,
  values,
  isFromUpdateTrainer = false,
  heading = '',
  handleCloseModal
}) => {
  const [imageFile, setImageFile] = useState(values?.profilePic);
  useEffect(() => {
    if (values?.profilePic) {
      setImageFile(values?.profilePic);
    }
  }, [values?.profilePic]);

  return (
    <form onSubmit={handleSubmit}>
      <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between' }}>
        <Typography color="textPrimary" variant="h2">
          {heading}
        </Typography>
        {handleCloseModal && (
          <CloseIcon sx={{ cursor: 'pointer' }} onClick={handleCloseModal} />
        )}
      </Box>
      {isFromUpdateTrainer && (
        <TextField
          fullWidth
          label="Traine Id"
          margin="normal"
          name="_Id"
          disabled
          type="text"
          value={values?._id}
          variant="outlined"
        />
      )}
      <TextField
        error={Boolean(touched.name && errors.name)}
        fullWidth
        helperText={touched.name && errors.name}
        label="Name"
        margin="normal"
        name="name"
        onBlur={handleBlur}
        onChange={handleChange}
        type="text"
        value={values.name}
        variant="outlined"
      />
      <TextField
        error={Boolean(touched.email && errors.email)}
        fullWidth
        helperText={touched.email && errors.email}
        label="Email Address"
        margin="normal"
        name="email"
        onBlur={handleBlur}
        onChange={handleChange}
        type="email"
        value={values.email}
        variant="outlined"
      />
      <Box sx={{ marginBottom: '8px' }}>
        <PhoneInput
          country={'us'}
          placeholder="Gym Phone Number"
          inputStyle={{
            height: '3.5rem',
            width: '100%',
            border:
              touched.mobileNumber && errors?.mobileNumber
                ? '1px solid red'
                : '1px solid rgba(0, 0, 0, 0.23)',
            marginTop: '16px'
          }}
          buttonClass={
            touched.mobileNumber && errors?.mobileNumber
              ? 'errorDropdown'
              : 'flagDropdown'
          }
          value={values?.mobileNumber}
          name="mobileNumber"
          onChange={(value, country) => {
            setFieldValue('mobileNumber', value);
            setFieldValue('callingCode', `+${country?.dialCode}`);
          }}
          inputProps={{
            required: true
          }}
          searchPlaceholder="Search"
          enableSearch
          countryCodeEditable={false}
        />
        {touched.mobileNumber && errors?.mobileNumber && (
          <p
            style={{
              color: 'red',
              fontFamily: 'Roboto',
              fontSize: '0.8rem',
              marginLeft: '15px',
              marginTop: '5px'
            }}
          >
            {errors?.gymPhone}
          </p>
        )}
      </Box>
      <FormControl
        variant="outlined"
        fullWidth
        margin="normal"
        id="gender-select"
      >
        <InputLabel id="gender-label">{STRINGS.GENDER}</InputLabel>
        <Select
          labelId="gender-label"
          id="gender"
          value={values.gender}
          onChange={handleChange}
          label="Gender"
          name="gender"
        >
          <MenuItem name="gender" value={0}>
            {STRINGS.MALE}
          </MenuItem>
          <MenuItem name="gender" value={1}>
            {STRINGS.FEMALE}
          </MenuItem>
        </Select>
      </FormControl>

      <TextField
        error={Boolean(touched.address && errors.address)}
        fullWidth
        helperText={touched.address && errors.address}
        label=" Address"
        margin="normal"
        name="address"
        onBlur={handleBlur}
        onChange={handleChange}
        type="text"
        value={values.address}
        variant="outlined"
      />

      <TextField
        error={Boolean(touched.experience && errors.experience)}
        fullWidth
        helperText={touched.experience && errors.experience}
        label="Experience(years)"
        margin="normal"
        name="experience"
        onBlur={handleBlur}
        onChange={handleChange}
        type="number"
        value={values.experience || ''}
        variant="outlined"
      />

      <TextField
        error={Boolean(touched.remarks && errors.remarks)}
        fullWidth
        helperText={touched.remarks && errors.remarks}
        label="Remarks"
        margin="normal"
        name="remarks"
        onBlur={handleBlur}
        onChange={handleChange}
        type="text"
        value={values.remarks}
        variant="outlined"
      />

      <TextField
        error={Boolean(touched.profilePic && errors.profilePic)}
        fullWidth
        helperText={touched.profilePic && errors.profilePic}
        label="Profile Pic"
        InputLabelProps={{
          shrink: true
        }}
        margin="normal"
        id="profilePic"
        name="profilePic"
        onBlur={handleBlur}
        inputProps={{
          accept: 'image/*'
        }}
        onChange={(event) => {
          setFieldValue('profilePic', event?.currentTarget?.files[0]);
          const file = event?.currentTarget?.files[0];
          if (!file) {
            setImageFile(null);
            return;
          }
          const fileImage = new FileReader();
          fileImage.readAsDataURL(file);
          fileImage.onload = () => {
            setImageFile(fileImage.result);
          };
        }}
        type="file"
        variant="outlined"
      />

      <ImagePicker pickedImage={imageFile} setImage={setImageFile} />

      <Box sx={{ py: 2 }}>
        <Button
          color="primary"
          disabled={isSubmitting}
          fullWidth
          size="large"
          type="submit"
          variant="contained"
        >
          {heading}
        </Button>
      </Box>
    </form>
  );
};

export default TrainerForm;
